/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-11-14 11:24:03
 * @LastEditors: WangYuhan
 */
import Vue from 'vue';

import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import './styles/element-variables.scss';

import '@/styles/index.scss'; // global css
import './assets/style/index.scss';
import 'viewerjs/dist/viewer.css';
import App from './App';
import store from './store';
import router from './router';

import './icons'; // icon
import './permission'; // permission control
import './utils/error-log'; // error log

// 常用方法挂在到VUE原型上
import base from '@/utils/base';

// register global utility filters
import filters from '@/utils/filters';
// 全局日志记录
import LogEvent from '@/utils/logEvent';
import directives from '@/utils/plugins.js';
import VueAnimateNumber from 'vue-animate-number';

Vue.use(directives);

Vue.use(VueAnimateNumber);
Object.keys(base).forEach(item => {
  Vue.prototype[item] = base[item];
});

Vue.use(Element, {
  size: 'small',
});
Vue.use(LogEvent);
Vue.prototype.$bus = new Vue();

// 注册全局组件
const files = require.context('@/components', true, /index\.vue$/);
files.keys().forEach(item => {
  const fileItem = files(item).default;
  // 如果组件内定义name 则需要全局引用的
  if (fileItem.name) {
    Vue.component(fileItem.name, fileItem);
  }
});

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
Vue.config.errorHandler = error => {
  console.error(error);
};
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});
